import styles from "./rolecard.module.css";
import { DashCardLoader } from "../../../components/LoaderC";

const RoleCardPermissions = ({ contentLoading, permissionList }) => {

    return (<>
        {contentLoading && <div className="Loader TableLoader" style={{ padding: '5px', boxShadow: 'none', height: '140px', overflow: 'hidden' }}><DashCardLoader /></div>}
        {!contentLoading && <>
            {/*permissionList?.map(item => {
                return <div>
                    <strong>{item?.title}</strong>
                    <p>{item?.userPerms}/{item?.total}</p>
                </div>
            })*/}
            {permissionList?.length > 0 ? <ul className={`${styles.PermissionList}`}>
                {permissionList?.slice(0, 4)?.map(i => {
                    return <li><p>{i}</p></li>
                })}
                {permissionList?.length > 4 && <li>
                    <p>and {permissionList?.length - 4} more...</p>
                </li>}
            </ul> : <div className={`${styles.NoDataMainS}`}>
                <div className={`${styles.NoDataIMGS}`}>
                    <img src="/static/img/no-permission.png" alt="No Data" />
                </div>
                <p className={`${styles.NoDataTextS}`}>Looks empty!</p>
                <p className={`${styles.NoDataTextSubS}`}>Add permissions to get started.</p>
            </div>}
        </>}
    </>)
}

export default RoleCardPermissions;